import { gql } from "@apollo/client";

import { GoalCompentenciesFragments } from "./get-goal-growth-connections-query";

export default gql`
  ${GoalCompentenciesFragments}
  mutation updateGoalGrowthConnectionsMutation(
    $artifactId: Int!
    $additionalFields: AdditionalArtifactInput
  ) {
    createOrUpdateArtifact(
      artifactId: $artifactId
      additionalFields: $additionalFields
    ) {
      artifact {
        id
        ... on GoalArtifactNode {
          ...GoalCompentenciesWithRoleFragment
        }
      }
    }
  }
`;
